/*
 * @Author: hanpeng
 * @Description: file
 * @Date: 2024-05-09 21:04:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-05-21 18:35:17
 */
import dayjs from 'dayjs';

/**
 * @param time 毫秒 || Date
 * @returns 
 * 显示逻辑
  刚刚（1分钟内）
  X 分钟前（取整数部分）
  X 小时前（取整数部分）
  昨天 XX:XX（小时:分钟）
  今年：X 月 X 日 XX:XX
  非今年：X 年 X 月 X 日
 */
import intl from '@/internationalzation/intl';
export const getRelativeTime = (time: string | Date): string => {
  const now = dayjs();
  const date = dayjs(Number(time));

  // 计算两个时间点之间的天数差
  const daysDiff = now.diff(date, 'days');

  // 计算两个时间点之间的分钟差
  const minutesDiff = now.diff(date, 'minutes');

  // 计算两个时间点之间的小时差
  const hoursDiff = now.diff(date, 'hours');

  // 计算两个时间点之间的年差
  const yearsDiff = now.diff(date, 'years');
  if (daysDiff === 0) {
    // 今天
    if (minutesDiff < 1) {
      return intl.t('刚刚');
    } else if (minutesDiff < 60) {
      return intl.t('{slot0} 分钟前', {
        slot0: Math.floor(minutesDiff)
      });
    } else if (hoursDiff < 24) {
      return intl.t('{slot0} 小时前', {
        slot0: Math.floor(hoursDiff)
      });
    } else {
      // 今年的其他日期
      return `${date.format(intl.t('M月D日 HH:mm'))}`;
    }
  } else if (daysDiff === 1) {
    // 昨天
    return intl.t('昨天 {slot0}', {
      slot0: date.format('HH:mm')
    });
  } else if (yearsDiff === 0) {
    // 今年但不是今天或昨天
    return `${date.format(intl.t('M月D日 HH:mm'))}`;
  } else {
    // 非今年
    return `${date.format(intl.t('YYYY年M月D日'))}`;
  }
};
export const dateFormat = (dateString: string, formatString = 'YYYY/MM/DD') => {
  return dayjs(Number(dateString)).format(formatString);
};
export const formatDuration = (milliseconds: number): string => {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const millisecondsPart = milliseconds % 1000;
  let formattedTime = '';
  // 如果毫秒不为0，则显示毫秒级
  if (millisecondsPart > 0) {
    formattedTime += `${millisecondsPart}ms`;
  }
  if (seconds > 0) {
    formattedTime = `${seconds}s${formattedTime}`;
  }
  if (minutes > 0) {
    formattedTime = `${minutes}min${formattedTime}`;
  }
  return formattedTime || '0ms';
};
function findAllTextNodes(element: HTMLElement) {
  const textNodes: HTMLElement[] = [];
  function traverse(node: ChildNode) {
    if (node.nodeType === Node.TEXT_NODE) {
      textNodes.push(node as HTMLElement);
    }
    if (node.nodeName === 'BUTTON') {
      return;
    }
    // 继续遍历子节点
    Array.from(node.childNodes).forEach(traverse);
  }
  traverse(element);
  return textNodes;
}
export const findDeepestLastNode = (ele: ChildNode | ParentNode): HTMLElement | null => {
  try {
    const arr = findAllTextNodes(ele as HTMLElement);
    let c = arr[arr.length - 1];
    while (arr.length && !c.textContent?.replace('\n', '')) {
      c = arr.pop() as HTMLElement;
    }
    return c.parentElement as HTMLElement;
  } catch {
    return null;
  }
};
